import type { CatalogKind } from '../../../services/admin';

type FilterableKind = Exclude<CatalogKind, 'other'>;

export const CATALOG_KINDS: FilterableKind[] = [
  'crossword-traditional',
  'crossword-direct',
  'wordsearch',
  'sudoku',
  'rebus',
  'quiz',
];

const LABELS: Record<CatalogKind, string> = {
  'crossword-traditional': 'Cruzada tradicional',
  'crossword-direct': 'Cruzada direta',
  wordsearch: 'Caça-palavras',
  sudoku: 'Sudoku',
  rebus: 'Rébus',
  quiz: 'Quiz',
  other: 'Outro',
};

export function kindLabel(kind: CatalogKind): string {
  return LABELS[kind];
}

export type CreationMethod = 'import' | 'generate' | 'editor';

const METHODS: Record<FilterableKind, CreationMethod[]> = {
  'crossword-traditional': ['import', 'generate'],
  'crossword-direct': ['import', 'editor'],
  sudoku: ['import', 'generate', 'editor'],
  wordsearch: ['generate', 'editor'],
  rebus: ['editor'],
  quiz: ['editor'], // formulário de perguntas, não o registry do Editor
};

export function creationMethods(kind: FilterableKind): CreationMethod[] {
  return METHODS[kind];
}

// kind do catálogo → kind do módulo no registry do Editor.
const EDITOR_KINDS: Partial<Record<CatalogKind, string>> = {
  'crossword-traditional': 'crossword-traditional',
  'crossword-direct': 'crossword',
  wordsearch: 'wordsearch',
  sudoku: 'sudoku',
  rebus: 'rebus',
};

export function editorKindOf(kind: CatalogKind): string | undefined {
  return EDITOR_KINDS[kind];
}
